<template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Department
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12 class="mb-4">
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="deptList"
          v-bind:options.sync="paginationDept"
          v-bind:search="search"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.value }}</td>
              <td>{{ row.item.label }}</td>
              <td align="center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignDept(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      headers: [
        { text: 'Department', align: 'left', value: 'label' },
        { text: 'Description', align: 'left', value: 'value' },
        TableConst.tableActionHeader
      ],
      deptList: [],
      loading: false,
      paginationDept: {
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doFetch()
  },
  methods: {
    async doFetch() {
      this.loading = true
      this.deptList = []
      try {
        const apiUrl = this.$store.state.commons.menu.deptList
        if (apiUrl) {
          const result = await this.$http.get(apiUrl)
          if (result && result.data && result.data.data) {
            this.deptList = result.data.data
          }
        }
      } catch (e) {}
      this.loading = false
    },
    closeDialog() {
      this.$emit('close')
    },
    assignDept(data) {
      this.$emit('assign-dept-info', data)
      this.$emit('assign-dept', data.value)
      this.$emit('close')
    }
  },
  computed: {},
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
